import { Link } from "react-router-dom";

export const Logo = ({ className = "h-14", to = "/" }) => (
  <Link to={to} data-testid="logo-link" className="inline-block shrink-0">
    <img src="/img/logo.png" alt="Doyebany Detailing" className={`${className} w-auto object-contain drop-shadow-[0_0_18px_rgba(255,210,31,0.25)]`} />
  </Link>
);
